import Swal from 'sweetalert2'
export default {
    methods: {
        showSchooldockAlert({ title, msg, htmlmsg, icon, confirmButtonColor, showCancelButton = false }) {
            const alert = {
                position: "top-end",
                customClass: {
                    container: "schooldock-alert-container",
                    popup: "schooldock-alert-popup",
                    title: "schooldock-alert-title",
                    htmlContainer: "schooldock-alert-message",
                    confirmButton: "schooldock-alert-confirm",
                    cancelButton: "schooldock-alert-cancel"
                },
                title,
                icon,
                focusConfirm: false,
                showCancelButton,
                confirmButtonText: `Okay <i class="fa fa-arrow-right pl-2" aria-hidden="true"></i>`,
                cancelButtonText: "Cancel",
                confirmButtonAriaLabel: "Close alert",
                cancelButtonAriaLabel: "Cancel and close alert",
                confirmButtonColor,
                showClass: {
                    popup: "animate__animated animate__fadeInDown animate__faster"
                },
                hideClass: {
                    popup: "animate__animated animate__fadeOutUp animate__faster"
                }
            };

            if (htmlmsg) {
                alert.html = htmlmsg;
            } else {
                alert.text = msg;
            }

            return Swal.fire(alert);
        },
        ShowAlertSuccess(msg, htmlmsg) {
            return this.showSchooldockAlert({ title: "Success", msg, htmlmsg, icon: "success", confirmButtonColor: "#16845b" });
        },
        ShowAlertWarning(msg, htmlmsg) {
            return this.showSchooldockAlert({ title: "Please check this", msg, htmlmsg, icon: "warning", confirmButtonColor: "#b7791f" });
        },
        ShowAlertError(msg, htmlmsg) {
            return this.showSchooldockAlert({ title: "Something went wrong", msg, htmlmsg, icon: "error", confirmButtonColor: "#c23b4a" });
        },
        ShowAlertInfo(msg, htmlmsg) {
            return this.showSchooldockAlert({ title: "Information", msg, htmlmsg, icon: "info", confirmButtonColor: "#2563a8" });
        },
        
    },
}